import { render, staticRenderFns } from "./AddDeleteRoleTable.vue?vue&type=template&id=198808c2"
import script from "./AddDeleteRoleTable.vue?vue&type=script&lang=js"
export * from "./AddDeleteRoleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports